import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { OrganisationRun } from '@/api/types/backend-dto-types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useFetchOrgRuns = (orgId: string) => {
  const fetcher = useFetcher();

  return useQuery<OrganisationRun[]>(
    [QueryEntity.OrganisationRuns, orgId],
    () => {
      const queryParams = new URLSearchParams({ orgId }).toString();
      return fetcher(`${APIBaseChronos}/api/org/runs?${queryParams}`);
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
